var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.81552,7.8287H4.18448A2.1873,2.1873,0,0,0,2,10.01317V14.949a2.1864,2.1864,0,0,0,2.18448,2.18342h1.93v3.57488a.53818.53818,0,0,0,.53849.5385H17.34708a.53818.53818,0,0,0,.53849-.5385V17.13244h1.92995A2.1864,2.1864,0,0,0,22,14.949V10.01317A2.1873,2.1873,0,0,0,19.81552,7.8287ZM5.00707,11.6581a.8227.8227,0,1,1,.82267-.82272A.823.823,0,0,1,5.00707,11.6581Zm11.80151,8.51073H7.19142V14.665h9.61716Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.84376,5.69148a.53763.53763,0,0,0-.11661-.17413L15.26107,3.05127a.54178.54178,0,0,0-.38139-.15842H6.65292a.53818.53818,0,0,0-.53849.5385V6.72226a.5385.5385,0,0,0,1.077,0V3.96984h7.14977v1.9289a.53818.53818,0,0,0,.53849.5385h1.9289v.285a.5385.5385,0,0,0,1.077,0V5.89874A.53758.53758,0,0,0,17.84376,5.69148ZM15.41817,4.7313l.62895.62895h-.62895Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29785,16.31h7.4043a.5385.5385,0,0,0,0-1.077H8.29785a.5385.5385,0,0,0,0,1.077Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29785,17.956h7.4043a.5385.5385,0,0,0,0-1.077H8.29785a.5385.5385,0,0,0,0,1.077Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29785,19.60089h7.4043a.5385.5385,0,0,0,0-1.077H8.29785a.5385.5385,0,0,0,0,1.077Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFax);
export default __webpack_public_path__ + "static/media/fax.1936ad322628b4160a04bfae64e43c81.svg";
export { ForwardRef as ReactComponent };